<template>
    <div id="auth">
        <van-dialog
            v-model="visible"
            :show-confirm-button="false"
            :close-on-popstate="true"
            @closed="handleClose"
            class="dialog-content"
        >
            <a v-if="closable" class="icon-close" @click="visible = false"></a>
            <p class="title">{{ title }}</p>
            <Form ref="form">
                <Field
                    class="field-input"
                    v-model="input.phoneNumber"
                    name="phone"
                    center
                    type="tel"
                    placeholder="请填写手机号"
                >
                    <template #button>
                        <div class="border"></div>
                        <CaptchaButton
                            class="captcha-button"
                            :source="source"
                            :phone="input.phoneNumber"
                        ></CaptchaButton>
                    </template>
                </Field>
                <Field
                    class="field-input"
                    v-model="input.captchaNumber"
                    name="captcha"
                    type="number"
                    maxlength="6"
                    placeholder="请填写验证码"
                ></Field>
                <Field
                    v-if="isSunRegistry"
                    class="field-input"
                    v-model="input.sun_name"
                    name="sun_name"
                    placeholder="请填写姓名"
                ></Field>
                <Field
                    v-if="isSunRegistry"
                    class="field-input"
                    v-model="input.street.code"
                    center
                    name="street"
                    placeholder="请选择街乡"
                >
                    <template #input>
                        <div class="street" @click="showStreet">
                            {{ input.street.name || "请选择街乡" }}
                        </div>
                    </template>
                </Field>
                <Field
                    v-if="isSunRegistry"
                    class="field-input"
                    v-model="input.identity_type.key"
                    center
                    name="identity_type"
                    placeholder="请选择身份"
                >
                    <template #input>
                        <div
                            class="street"
                            @click="() => showPicker('identity_type')"
                        >
                            {{ input.identity_type.text || "请选择身份" }}
                        </div>
                    </template>
                </Field>

                <Field
                    v-if="isSunRegistry && input.identity_type.key === 'student'"
                    class="field-input"
                    v-model="input.school.key"
                    center
                    name="school"
                    placeholder="请选择身份"
                >
                    <template #input>
                        <div class="street" @click="() => showPicker('school')">
                            {{ input.school.text || "请选择学校" }}
                        </div>
                    </template>
                </Field>
            </Form>
            <Button
                type="primary"
                size="small"
                @click="handleLogin"
                class="confirm-button"
                >{{ btnWord }}</Button
            >
            <span
                :style="{
                    textDecoration: source === 'sun' ? 'undeline' : 'none',
                }"
                class="action-word"
                @click="changeAction"
                >{{ changeWord }}</span
            >
        </van-dialog>
        <Street
            ref="street"
            @confirm="(val) => (input.street = val)"
            :value.sync="input.street"
        ></Street>
        <Picker
            ref="picker"
            @confirm="(val, type) => (input[type] = val)"
            :values.sync="input"
        ></Picker>
    </div>
</template>

<script>
// components
import { Dialog, Form, Field, Button, Toast } from "vant";
import CaptchaButton from "./CaptchaButton";
import Street from "./Street";
import Picker from "./Picker";

// utils
import * as Cookie from "@/utils/cookie";
import { userApi } from "@/apis";
import { getGbLen } from "@/utils/func";

const INPUT_INITIAL = {
    phoneNumber: "",
    captchaNumber: "",
    sun_name: undefined,
    street: {
        code: undefined,
        name: undefined,
    },
    identity_type: {
        code: undefined,
        name: undefined,
    },
    school: {
        code: undefined,
        name: undefined,
    },
};

export default {
    name: "Auth",
    components: {
        [Dialog.Component.name]: Dialog.Component,
        Form,
        Field,
        CaptchaButton,
        Street,
        Picker,
        Button,
    },
    data() {
        return {
            // 弹窗是否显示
            visible: false,
            closable: false,
            // 0: 登录，1: 注册
            action: 0,
            // 来源。默认为朝阳
            source: "sun",
            schools: {},
            // 检测promise
            checkPromise: {
                resolve: null,
                reject: null,
            },
            input: {
                phoneNumber: "",
                captchaNumber: "",
                sun_name: undefined,
                identity_type: {
                    code: undefined,
                    name: undefined,
                },
                street: {
                    code: undefined,
                    name: undefined,
                },
                school: {
                    code: undefined,
                    name: undefined,
                },
            },
        };
    },
    watch: {
        // action切换时，清除姓名、身份、学校、街道信息
        action() {
            Object.assign(this.input, {
                captchaNumber: "",
                sun_name: undefined,
                identity_type: {
                    code: undefined,
                    name: undefined,
                },
                street: {
                    code: undefined,
                    name: undefined,
                },
                school: {
                    code: undefined,
                    name: undefined,
                },
            });
        },
    },
    computed: {
        title() {
            return ["登录", "新用户注册"][this.action];
        },
        btnWord() {
            return ["登录", "注册"][this.action];
        },
        changeWord() {
            return this.source === "sun"
                ? ["新用户注册", "已有账号，登录"][this.action]
                : "新用户首次登录即为注册";
        },
        isSunRegistry() {
            return this.source === "sun" && this.action === 1;
        },
    },
    methods: {
        async _initData() {
            this.input = {
                ...INPUT_INITIAL,
            };

            if (!Object.keys(this.schools).length) {
                try {
                    const { body } = await userApi.schoolsGet();
                    let othersIndex = -1
                    let schools = body.map((item, index) => {
                        othersIndex = item.name == '其他' ? index : othersIndex
                        return {
                            key: item.school_id,
                            text: item.name
                        }
                    })

                    this.schools = othersIndex >= 0 ? schools.concat(schools.splice(othersIndex, 1)) : schools
                } catch (error) {
                    this.schools = {};
                }
            }
        },
        /**
         * 验证数据是否有误
         * @return errorMessage
         */
        validate() {
            const isSunRegistry = this.source === "sun" && this.action === 1;
            if (!/^1[3456789]\d{9}$/.test(this.input.phoneNumber))
                return "请输入正确的手机号";
            else if (!/^\d{6}$/.test(this.input.captchaNumber))
                return "请输入正确的验证码";
            else if (isSunRegistry && !this.input.sun_name) return "请输入姓名";
            else if (isSunRegistry && getGbLen(this.input.sun_name) > 20)
                return "姓名最多输入10个中文字符";
            else if (isSunRegistry && !/^\d{6}$/.test(this.input.street.code))
                return "请选择地址";
            else if (isSunRegistry && !this.input.identity_type.key)
                return "请选择身份";
            else if (
                isSunRegistry &&
                this.input.identity_type.key === "student" &&
                !this.input.school.key
            )
                return "请选择学校";
            else return undefined;
        },
        /**
         * 切换登录/注册
         */
        changeAction() {
            if (this.source === "sun") this.action = this.action === 0 ? 1 : 0;
        },
        /**
         * 外部需要登录检测时调用
         */
        check(options = {}) {
            console.log(options);
            const {
                source = "sun",
                showModal = true,
                closable = false,
            } = options;
            this.closable = closable;
            return new Promise((resolve, reject) => {
                // check login token
                const login = Cookie.get("uid");
                // const login = false

                if (login) resolve(login);
                else if (!showModal) {
                    resolve(undefined);
                } else {
                    // 初始化数据
                    this._initData();
                    // 朝阳登录默认弹注册
                    this.action = source === "sun" ? 1 : 0;
                    this.source = source;
                    // 显示弹窗
                    this.visible = true;

                    this.checkPromise.resolve = resolve;
                    this.checkPromise.reject = reject;
                }
            });
        },
        /**
         * 检测是否是作者
         */
        checkIsAuthor(uid = "author") {
            return uid === Cookie.get("uid");
        },
        /**
         * 显示街道选择
         */
        showStreet() {
            this.$refs.street.show();
        },
        /**
         * 显示选择器选择
         */
        showPicker(type) {
            this.$refs.picker.show(
                type,
                type === "school" ? this.schools : null
            );
        },
        /**
         * 处理登录流程
         */
        async handleLogin() {
            const err = this.validate();
            if (err) {
                return Toast(err);
            }

            try {
                const { body } = await userApi.userLoginPost({
                    body: {
                        phone: this.input.phoneNumber,
                        verify_code: this.input.captchaNumber,
                        sun_name: this.input.sun_name || undefined,
                        street_code: this.input.street.code || undefined,
                        identity_type: this.input.identity_type.key || undefined,
                        school_id: this.input.identity_type.key === 'student' ? this.input.school.key && parseInt(this.input.school.key) || undefined : undefined,
                        source: this.source,
                        approach: this.source === 'sun' ? 'chaoyang' : 'nongyebu'
                    }
                })
                if (body?.uid) {
                    // 登录成功
                    // Cookie.write('uid', body.uid, 365)
                    Cookie.write('uid', body.uid, body.expires_in)
                    Cookie.write('access_token', body.access_token, body.expires_in)
                    Toast(this.action === 0 ? '登录成功' : '注册成功')
                }

                this.visible = false;
            } catch(err) {
                Object.assign(this.input, {
                    captchaNumber: "",
                });

                if(err.body && err.body.error_code === 'cannot_change_identity') {
                    Toast('您已注册请直接登陆')

                    return this.action = 0
                }
            }

        },
        /**
         * 处理关闭弹窗
         */
        handleClose() {
            // 关闭时，如登录成功则resolve，反之reject
            if (Cookie.get("uid")) {
                this.checkPromise.resolve &&
                    this.checkPromise.resolve(Cookie.get("uid"));
            } else {
                this.checkPromise.reject &&
                    this.checkPromise.reject(new Error("cancel"));
            }
        },
    },
};
</script>

<style lang="less" scoped>
#auth {
    .dialog-content {
        padding: 2rem 2.65rem 3rem;
        box-sizing: border-box;
        text-align: center;
        position: absolute;
        .icon-close {
            padding: 1.35rem 1.35rem 2rem 2rem;
            font-size: 11px;
            position: absolute;
            right: 0;
            top: 0;
        }
        .title {
            font-size: 16px;
            line-height: 1em;
            color: #082754;
            font-weight: bolder;
            text-align: center;
            margin-bottom: 1.75rem;
            margin-top: 1rem;
        }
        .action-word {
            font-size: 14px;
            display: block;
            text-align: center;
            text-decoration: underline;
            color: #082754;
        }
        .field-input {
            font-size: 12px;
            padding: 1rem;
            border-radius: 2rem;
            background-color: #f2f2f2;
            margin-bottom: 1rem;
        }
        .confirm-button {
            font-size: 16px;
            line-height: 1em;
            background-color: #123e7f;
            color: #fff;
            padding: 1.8rem 4.85rem;
            margin: 1rem 0 1.5rem 0;
            border-radius: 2rem;
            border: none;
        }
        .border {
            width: 1px;
            height: calc(100% + 2rem);
            background-color: #bfbfbf;
            position: absolute;
            top: -1rem;
        }
        .captcha-button {
            background-color: transparent;
            color: #595959;
            border: none;
            padding-left: 1rem;
            height: auto;
            width: 80px;
        }
        .street {
            width: 100%;
        }
    }
}
</style>
